import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useRef } from 'react';

import {
  closeItemAtom,
  openToItemAtom,
} from '@/features/developer-tools/state/dev-tools-panel.state';
import { displayTemplatePreviewStorageAtom } from '@/features/ux-config/display-template/state/display-template-preview.state';

/**
 * Opens/closes the Template Preview DevTool when UX Config writes the session
 * preview atom. Keeps panel lifecycle in developer-tools (not ux-config).
 */
export const useDisplayTemplatePreviewPanelBridge = (): void => {
  const previewStorage = useAtomValue(displayTemplatePreviewStorageAtom);
  const openToItem = useSetAtom(openToItemAtom);
  const closeItem = useSetAtom(closeItemAtom);
  const wasActiveRef = useRef(false);

  useEffect(() => {
    const isActive = !!previewStorage?.jsonContent;
    if (isActive && !wasActiveRef.current) {
      openToItem('display-template-preview');
    } else if (!isActive && wasActiveRef.current) {
      closeItem('display-template-preview');
    }
    wasActiveRef.current = isActive;
  }, [closeItem, openToItem, previewStorage?.jsonContent]);
};
